export const BIGQUERY_NAME = "bigquery";
export const BIG_QUERY_DISPLAY_NAME = "BigQuery";

export const BASE_URL_PREFIX = `/config/${BIGQUERY_NAME}`;
